import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { throwError } from "rxjs";
import { map, catchError, mergeMap } from "rxjs/operators";
import { ErrorDialogService } from "../core/services/dialog/";
import { AuthenticationService, AccountService } from "../core";
import { WebsocketService } from "../websockets";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { DeviceRegistrationService } from "../core/services/device-registration.service";

// URL prefixes for the news/REsource section (listing + detail pages across all
// its aliases). On a 401, these reload in place instead of redirecting home.
const NEWS_SECTION_PREFIXES: string[] = [
  "/news",
  "/noticias",
  "/notícias",
  "/insights",
  "/resource",
  "/insight-preview"
];

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthenticationService,
    private account: AccountService,
    private websocketService: WebsocketService,
    private route: Router,
    private deviceRegistration: DeviceRegistrationService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    let storageTokenVal = null;
    let storageUserVal = null;
    try {
      let value = "; " + document.cookie;
      let parts = value.split("; " + "tokenSIILA" + "=");
      let token = parts
        .pop()
        .split(";")
        .shift();
      storageTokenVal = localStorage.getItem("token");
      storageUserVal = localStorage.getItem("user");
      if (token != storageTokenVal) {
        localStorage.setItem("token", token);
        storageTokenVal = token;
      }
    } catch (error) {}
    const token: any = storageTokenVal;
    const user: any = storageUserVal;
    if (token) {
      req = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + token)
      });
    }

    if (!req.headers.has("Content-Type")) {
      req = req.clone({
        headers: req.headers.set("Content-Type", "application/json")
      });
    }

    req = req.clone({ headers: req.headers.set("Accept", "application/json") });
    req = req.clone({ headers: req.headers.set("X-Client-App", "HOMEPAGE") });

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401 && token) {
          this.auth.$isLoginSubject.next(false);
          this.account.currentUser$.next(null);
          this.websocketService.kick();
          try {
            const currentUrl = this.route.url;
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("photoUser");
            this.deviceRegistration.deleteCookieToken();
            const isNewsSection = NEWS_SECTION_PREFIXES.some(prefix =>
              currentUrl.startsWith(prefix)
            );
            if (isNewsSection) {
              window.location.reload();
            } else {
              this.route.navigateByUrl("/");
            }
          } catch (err) {}
        }
        return throwError(error);
      })
    );
  }
}
